
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12736',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12736",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9775",
  "foundations-components": "static-1.8160",
  "foundations-components-legacy": "static-1.1185",
  "foundations-theming": "static-1.4545",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8134",
  "hub-http-shared-msw-handlers": "static-1.10249",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11589",
  "I18n": "static-7.1638",
  "jasmine-runner": "static-1.6572",
  "marketplace-storefront-base": "static-1.12799",
  "quartz": "static-1.7173",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16797",
  "reactive-variable-buffer-atom": "static-1.2971",
  "reporting-testing-lib": "static-1.9968",
  "settings-ui-lib": "static-1.12634",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7346",
  "ui-addon-i18n": "static-1.11262",
  "ui-addon-react-router-dom": "static-1.9651",
  "unified-auth": "static-1.628",
  "unified-auth-core-lib": "static-1.910",
  "usage-tracker": "static-1.7462",
  "usage-tracker-core": "static-1.7312",
  "customer-data-property-utils": "static-1.8209",
  "hub-http": "static-1.6336",
  "integrations-lib": "static-1.16519",
  "marketplace-ui-common": "static-1.20152",
  "property-management-iframe": "static-1.13550",
  "quartz-config": "static-1.951",
  "quartz-core": "static-1.6392",
  "quartz-routing": "static-1.603",
  "quick-fetch": "static-1.4001",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4770",
  "ts-schema": "static-1.4164",
  "ui-universal-auth": "static-1.9114",
  "UIComponents": "static-3.8535",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3481",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3450",
  "quartz-webpack": "static-1.3397",
  "bend-plugin-quartz-routing": "static-1.251",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4429",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.4987",
  "foundations-theming-specialty": "static-1.2261",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9536",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.36",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5425",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2190",
  "ui-fonts": "static-1.851",
  "ui-images": "static-2.1181",
  "bend-plugin-foundations-theming": "static-1.3028",
  "foundations-theming-base": "static-1.3530",
  "stylex": "static-1.35",
  "HeadJS": "static-2.769",
  "hs-test-utils-bend-plugin": "static-1.3245",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4439",
  "ai-components-ui-library": "static-1.9246",
  "ai-rendering-library": "static-1.10588",
  "chirp-fetch": "static-1.2000",
  "connections-embed-lib": "static-1.1208",
  "copilot-toolkit": "static-1.11433",
  "feedback-loader": "static-1.29514",
  "laboratory-lib": "static-3.7267",
  "marketplace-embed": "static-1.22451",
  "marketplace-ui-details": "static-1.10047",
  "marketplace-ui-reviews": "static-1.20107",
  "marketplace-ui-tracking": "static-1.14322",
  "sanitize-text": "static-1.8259",
  "ui-addon-video-player": "static-1.8817",
  "usage-tracker-multi": "static-1.5876",
  "usage-tracker-session-replay": "static-1.5148",
  "wootric-nps": "static-1.7066",
  "quartz-head": "static-1.838",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4764",
  "immer": "static-1.33",
  "immerable": "static-1.4264",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2570",
  "reporting-data": "static-1.68035",
  "cssUtils": "static-1.824",
  "flux-actions": "static-1.346",
  "HubStyle": "static-2.11896",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10320",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10476",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7452",
  "icons": "static-2.654",
  "marketplace-ui-apps-core": "static-1.18684",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4625",
  "foundations-components-test-utils": "static-1.5643",
  "quartz-i18n": "static-1.848",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.14",
  "ads-unified-auth-lib": "static-1.371",
  "google-sheets-integration-lib": "static-1.578",
  "microsoft-drive-integration-lib": "static-1.709",
  "surveymonkey-integration-lib": "static-1.34",
  "slack-ui-library": "static-1.10509",
  "fsm": "static-1.3842",
  "customer-data-objects": "static-1.7792",
  "property-translator": "static-1.5510",
  "hs-locale-management": "static-1.165",
  "frontend-preferences-client": "static-1.8041",
  "hs-promise-utils": "static-1.5705",
  "hubspot-apollo-client": "static-1.4991",
  "integrations-error-boundary-lib": "static-1.13934",
  "integrations-tracking-lib": "static-1.5719",
  "native-integrations-shared-strings": "static-1.7896",
  "reselect": "static-2.16",
  "sanitize": "static-1.4589",
  "superstore": "static-1.4872",
  "ui-shepherd-react": "static-3.10359",
  "ai-settings-ui-library": "static-1.8071",
  "hub-http-janus": "static-1.845",
  "hubspotter-http": "static-1.4734",
  "immutable-less": "static-1.4767",
  "marketplace-ui-client-types": "static-1.17559",
  "nav-meta": "static-1.29929",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18149",
  "inbound-db-properties-service-client": "static-1.3928",
  "property-management-common": "static-1.5838",
  "ui-addon-iframeable": "static-1.9180",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.544",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.848",
  "quartz-test": "static-1.848",
  "quartz-tracking": "static-1.552",
  "trellis-components": "static-1.2209",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.180",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21837",
  "ContentUtils": "static-1.68696",
  "customer-data-objects-ui-components": "static-1.13143",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2611",
  "breeze-engine-core": "static-1.395",
  "breeze-onboarding-components": "static-1.250",
  "customer-data-filters-ui": "static-1.40198",
  "customer-data-reference-ui-components": "static-1.13287",
  "embedded-academy-lib": "static-1.14741",
  "ExportDialog": "static-6.10493",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41596",
  "reporting-snowflake": "static-1.56653",
  "reporting-ui-components": "static-2.65306",
  "reporting-visualizations": "static-1.60111",
  "trellis-theming": "static-1.1055",
  "ui-addon-teams": "static-1.21697",
  "integrations-reconnect-lib": "static-1.181",
  "magpie-lib": "static-1.5625",
  "navigation-components": "static-1.18292",
  "breeze-engine-lib": "static-1.1117",
  "magpie-types": "static-1.5085",
  "simple-logging-lib": "static-1.3162",
  "ai-studio-lib": "static-1.11952",
  "app-governance-lib": "static-1.1918",
  "developer-experience-shared-components": "static-1.10627",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8121",
  "ui-product-approvals": "static-1.28613",
  "ui-tool-access": "static-1.10262",
  "usage-based-billing-components-lib": "static-1.9421",
  "usage-tracker-anonymous": "static-1.5879",
  "usage-tracker-public": "static-1.7273",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3670",
  "persist-promise": "static-1.3813",
  "reference-resolvers": "static-1.8288",
  "ui-extensibility-client-types": "static-1.4037",
  "hubspot-apollo-cache": "static-1.450",
  "universal-page-editor-lib": "static-1.3131",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3101",
  "atom": "static-1.5189",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6087",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1656",
  "crm-component-utils": "static-1.39384",
  "crm-properties-common-lib": "static-1.6002",
  "customer-data-properties": "static-1.51970",
  "framework-data-schema-resolvers": "static-1.7006",
  "property-value-citations": "static-1.2584",
  "reference-resolvers-lite": "static-1.8211",
  "ui-business-units-lib": "static-1.9180",
  "navigation-messaging": "static-1.7619",
  "hubspotter-http-shared-msw-handlers": "static-1.10247",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4929",
  "content-icons-ui": "static-1.2258",
  "customer-data-ui-utilities": "static-1.9939",
  "conversations-skeleton-state": "static-1.7361",
  "crm-message-bus": "static-1.43283",
  "customer-data-filters-ui-msw-helpers": "static-1.22633",
  "events-data-lib": "static-1.345",
  "FormUrlGenerator": "static-2.4835",
  "framework-builder-read-service-client": "static-1.4087",
  "framework-data-schema-quick-fetch": "static-1.6911",
  "multi-account-reference-resolvers": "static-1.1096",
  "onboarding-tours": "static-1.16818",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14011",
  "academy-common-lib": "static-1.14201",
  "content-assistance-lib": "static-1.7938",
  "dashboard-lib": "static-1.81978",
  "file-manager-components": "static-1.23944",
  "getting-started-shared-tasks": "static-1.18732",
  "hubspot-prosemirror": "static-1.18568",
  "hubspot-prosemirror-plugins": "static-1.18560",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20031",
  "share-with-third-party-component-lib": "static-1.8818",
  "ui-addon-draggable": "static-3.4873",
  "ui-asset-management-lib": "static-1.11178",
  "user-context": "static-1.5223",
  "growth-payments-core": "static-1.25717",
  "reporting-plugins": "static-1.10503",
  "reporting-reports": "static-1.67713",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.839",
  "nest": "static-1.345",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10741",
  "framework-listing-lib": "static-2.29017",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30976",
  "apps-service-types": "static-1.3913",
  "oauth-service-types": "static-1.4367",
  "react-dnd-compat": "static-1.4728",
  "ui-product-approvals-common": "static-1.508",
  "onboarding-scopes": "static-1.6574",
  "onboarding-tours-client": "static-1.5033",
  "platform-infra-nav-components": "static-1.7755",
  "subscription-experience-data-types": "static-1.15064",
  "crm-record-cards-service-types": "static-1.3671",
  "location-customization-utils-lib": "static-1.9599",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6090",
  "signup-constants": "static-1.19123",
  "signup-ui-url-generator": "static-2.8171",
  "card-properties-lib": "static-1.44539",
  "commerce-subscription-lib": "static-1.37409",
  "crm-actions": "static-1.6454",
  "crm-cards-sdk": "static-1.43930",
  "customer-data-properties-shared-msw-handlers": "static-1.9576",
  "customer-data-tracking": "static-1.7001",
  "hs-resources": "static-1.286",
  "pulse": "static-1.712",
  "calling-global-api": "static-1.64907",
  "calling-internal-common": "static-1.31423",
  "calling-lifecycle-internal": "static-1.66289",
  "calling-lifecycle-messages": "static-1.58583",
  "commerce-products-lib": "static-1.9983",
  "conditional-properties-service-client": "static-1.3879",
  "crm-links": "static-1.6421",
  "crm-pipelines-api-client-types": "static-1.4220",
  "external-options-client-types": "static-1.4210",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4300",
  "meetings-icalendar-utils-lib": "static-1.747",
  "multi-currency-client-types": "static-1.3773",
  "object-builder-ui-client": "static-1.49140",
  "pipeline-validation-client-types": "static-1.4049",
  "smart-property-lib": "static-1.7805",
  "tiered-pricing": "static-1.1515",
  "ui-addon-form-validation": "static-1.11103",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.125",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1167",
  "growth-data-modal": "static-1.5614",
  "growth-onboarding-confetti": "static-1.3179",
  "growth-onboarding-next-action-utils": "static-1.2248",
  "onboarding-tours-utils": "static-1.885",
  "ui-shepherd-tracker": "static-1.7740",
  "academy-service-client": "static-1.3797",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39443",
  "FileManagerLib": "static-1.39584",
  "SafeStorage": "static-1.4513",
  "video-embed": "static-1.36142",
  "ui-coaching-tips": "static-1.28881",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11650",
  "video-data-lib": "static-1.35308",
  "content-media-capture": "static-1.4861",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23827",
  "ui-addon-emoji-picker": "static-1.10000",
  "EmailSignatureEditor": "static-1.24628",
  "viral-links-lib": "static-1.7181",
  "data-token-picker": "static-1.16611",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.338",
  "timezone-utils": "static-2.5357",
  "seat-types-lib": "static-1.270",
  "getting-started-shared-tasks-store": "static-1.17850",
  "ui-addon-opt": "static-4.8474",
  "campaign-roi-lib": "static-1.9440",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25676",
  "framework-data-table": "static-2.12180",
  "marketing-platform-lib": "static-1.6979",
  "nudge-client-utils": "static-1.2823",
  "nudge-custom-ui-functions": "static-1.1230",
  "switchboard-lib": "static-1.337",
  "app-users-service-client": "static-1.5722",
  "app-users-service-types": "static-1.5130",
  "mini-checkout-client": "static-1.27091",
  "onboarding-utils": "static-1.5472",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28866",
  "edison-service-client-types": "static-1.503",
  "crm_data": "static-4.92329",
  "customer-data-sidebar": "static-2.46333",
  "enrichment-properties-lib": "static-1.16923",
  "ui-addon-draggable-compat": "static-2.4373",
  "universal-record-utils-lib": "static-1.1246",
  "commerce-billing-lib": "static-1.19465",
  "commerce-shared-components-lib": "static-1.18817",
  "commerce-tools-ui-lib": "static-1.10684",
  "crm-fe-perf": "static-1.23016",
  "event-emitter": "static-1.1062",
  "bend-plugin-pulse": "static-1.215",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31430",
  "shared-worker-versioning": "static-1.11149",
  "calling-usage-tracker": "static-1.6657",
  "voice-sms-access-library": "static-1.1438",
  "commerce-permissions": "static-1.890",
  "products-iframe-lib": "static-1.8248",
  "products-ui-components-shared-msw-handlers": "static-1.10631",
  "data-agent-kit": "static-1.387",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10332",
  "policy-lib": "static-1.6895",
  "react-tinymce": "static-1.55546",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10395",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54672",
  "tinymce-plugins": "static-1.57786",
  "tinymce-themes": "static-1.56642",
  "onboarding-data-sync-lib": "static-1.2161",
  "growth-onboarding-next-action-components": "static-1.2276",
  "user-context-client": "static-1.4693",
  "audio-components": "static-1.6094",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37095",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4649",
  "video-components": "static-1.13652",
  "outpost": "static-1.4283",
  "growth-onboarding-feedback-components": "static-1.6692",
  "content-media-composition-data-lib": "static-1.12665",
  "content-media-compositions": "static-2.16672",
  "media-bridge-lib": "static-1.19126",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4538",
  "commerce-tours-lib": "static-1.6311",
  "growth-onboarding-reliability": "static-1.5194",
  "sales-checkout-service-client": "static-1.3707",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21879",
  "sales-email-signature-service-client": "static-1.3964",
  "ts-utils-lib": "static-1.287",
  "crm-export-dialog": "static-1.6398",
  "crm-index-associations-lib": "static-1.6555",
  "crm-view-components": "static-1.622",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7444",
  "nudge-custom-function-registry": "static-1.2580",
  "nudge-renderer-utils": "static-1.2899",
  "whisper-core-api": "static-1.6872",
  "InboxConnectUtils": "static-4.15114",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5802",
  "settings-content-modals": "static-1.46408",
  "crm_universal": "static-1.22213",
  "customer-data-email": "static-1.18240",
  "card-payment-highlight-lib": "static-1.37505",
  "card-subscription-highlight-lib": "static-1.39832",
  "commerce-contract-lib": "static-1.12619",
  "invoices-highlight-card-lib": "static-1.55102",
  "orders-highlight-card-lib": "static-1.21781",
  "products-highlight-card-lib": "static-1.18266",
  "quotes-highlight-card-lib": "static-1.72400",
  "crm-source-interpretation-lib": "static-1.5457",
  "crm-object-search-query-utilities": "static-1.9843",
  "utility-belt": "static-1.2645",
  "payments-enrollment-embed-lib": "static-1.23251",
  "stripe-embedded-components": "static-1.7713",
  "customer-data-rte": "static-1.33300",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5953",
  "payments-post-enroll-local-storage-lib": "static-1.5220",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38490",
  "trials-service-types": "static-1.3996",
  "calling-orchestration-schema": "static-1.36215",
  "sales-views-client-types": "static-1.4370",
  "hub-http-contrib": "static-1.3157",
  "interframe": "static-3.4874",
  "tinymce-data": "static-1.40757",
  "ui-addon-sales-email": "static-1.5322",
  "layout-dnd-components": "static-1.12669",
  "layout-dnd-utils": "static-1.11644",
  "ui-brand-identity-lib": "static-1.15694",
  "NamespacedHubStyle": "static-2.9137",
  "meetings-connect-utils-lib": "static-1.7719",
  "social-insights-client-types": "static-1.22335",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4283",
  "checkout-sdk": "static-3.23934",
  "company-details-components": "static-1.6311",
  "payment-method-components": "static-1.6985",
  "pricing-pages-ui-components": "static-1.14701",
  "quote-checkout-service-types": "static-1.3579",
  "upgrade-catalog-service-types": "static-1.3635",
  "access-control-lib": "static-1.10549",
  "EmailComponents": "static-1.55088",
  "EmailData": "static-1.53765",
  "redux-less": "static-2.9596",
  "sequences-lib": "static-1.8244",
  "ui-gdpr-components": "static-1.10463",
  "products-ui-components": "static-1.40501",
  "accounting-integrations-ui-components": "static-1.7253",
  "invoices-ui-lib": "static-1.55118",
  "commerce-products-api": "static-1.2463",
  "invoices-iframe-lib": "static-1.57176",
  "quotes-modal-lib": "static-1.103078",
  "quotes-ui-lib": "static-1.81121",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28566",
  "ContentData": "static-1.68771",
  "layout-data-lib": "static-1.9969",
  "checkout-service-types": "static-1.3880",
  "hub-http-rxjs": "static-1.810",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4051",
  "billing-payments-client-types": "static-1.4103",
  "react-performance-metrics-lib": "static-1.670",
  "account-and-billing-fintech-outages": "static-3.18718",
  "pricing-pages-api": "static-1.14566",
  "ContentComponents": "static-2.71652",
  "marketing-contacts-lib": "static-1.10427",
  "marketing-email-service-types": "static-1.1983",
  "messaging-editing-lib": "static-1.46600",
  "messaging-usage-based-billing-components-lib": "static-1.1462",
  "automation-ui-source-apps": "static-1.19217",
  "automation-ui-types": "static-1.20135",
  "messaging-types-lib": "static-1.46337",
  "onboarding-settings-client": "static-1.4617",
  "sequences-client-types-lib": "static-1.8101",
  "commerce-tax-lib": "static-1.649",
  "price-books-api": "static-1.1241",
  "price-books-components": "static-1.1299",
  "property-description-translator": "static-1.3954",
  "ramp-editor": "static-1.449",
  "commerce-analytics-service-client": "static-1.3695",
  "totals-ui-components": "static-1.23910",
  "SalesContentIndexUI": "static-3.9404",
  "advanced-menus-core": "static-1.15320",
  "advanced-menus-lib": "static-1.12233",
  "ui-memberships-settings-lib": "static-1.34350",
  "segments-query-core": "static-1.1534",
  "automation-ui-ubb": "static-1.6051",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7452",
  "data-token-views": "static-1.16592",
  "forms-utils-lib": "static-1.12799",
  "payments-embed-points-lib": "static-1.13269",
  "simple-menus-core": "static-1.15319",
  "simple-menus-lib": "static-1.16836",
  "videoconference-integration-components": "static-1.6992",
  "mc-hard-limits-client-types": "static-1.11",
  "marketing-contacts-client": "static-1.7625",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77430",
  "short-messages-app-service-client": "static-1.4037",
  "web-interactives-components": "static-1.13963",
  "web-interactives-data": "static-1.13964",
  "messaging-shared-utils-lib": "static-1.911",
  "messaging-user-info-utils-lib": "static-1.1081",
  "email-portal-health-service-types": "static-1.1090",
  "line-items-api": "static-1.859",
  "commerce-totals-service-types": "static-1.3901",
  "FireAlarmUi": "static-1.4590",
  "sales-templates-service-types-lib": "static-1.4252",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22071",
  "automation-ui-usage-tracking": "static-1.21534",
  "data-studio-ubb": "static-1.3055",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27281",
  "collaboration-sidebar": "static-1.58183",
  "content-management-data-lib": "static-1.5607",
  "copilot-plugins": "static-1.11406",
  "cta-picker": "static-1.36703",
  "customer-agent-discovery-components-lib": "static-1.3410",
  "editor-components": "static-1.13398",
  "editor-iframe-lib": "static-1.8564",
  "error-messaging-js": "static-1.5306",
  "FormsCommonComponents": "static-1.86125",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10760",
  "SharedLegalStrings": "static-1.1858",
  "smart-content-core": "static-1.42755",
  "smart-content-lib": "static-1.43408",
  "social-composer-lib": "static-1.59570",
  "structured-content-lib": "static-1.25498",
  "theme-previewer-lib": "static-1.53557",
  "tinymce-copilot": "static-1.16740",
  "xray-recommendation-lib": "static-1.8054",
  "automation-ui-routing": "static-1.21492",
  "sql-reporting-client-types": "static-1.5728",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42446",
  "campaigns-utils-lib": "static-1.3306",
  "reporting-enablement": "static-1.23318",
  "chatspot-widget-iframe": "static-1.21828",
  "collaboration-sidebar-common": "static-1.2980",
  "forms-ai-lib": "static-1.4499",
  "codemirror-dlb": "static-1.58989",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6549",
  "report-customization-components": "static-1.13484",
  "data-quality-ui-library": "static-1.13333",
  "reporting-filters": "static-1.609",
  "reporting-insights-lib": "static-1.2083"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12736",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9775",
  "foundations-components": "/foundations-components/static-1.8160",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1185",
  "foundations-theming": "/foundations-theming/static-1.4545",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8134",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10249",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11589",
  "I18n": "/I18n/static-7.1638",
  "jasmine-runner": "/jasmine-runner/static-1.6572",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12799",
  "quartz": "/quartz/static-1.7173",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16797",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2971",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9968",
  "settings-ui-lib": "/settings-ui-lib/static-1.12634",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7346",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11262",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9651",
  "unified-auth": "/unified-auth/static-1.628",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.910",
  "usage-tracker": "/usage-tracker/static-1.7462",
  "usage-tracker-core": "/usage-tracker-core/static-1.7312",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8209",
  "hub-http": "/hub-http/static-1.6336",
  "integrations-lib": "/integrations-lib/static-1.16519",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20152",
  "property-management-iframe": "/property-management-iframe/static-1.13550",
  "quartz-config": "/quartz-config/static-1.951",
  "quartz-core": "/quartz-core/static-1.6392",
  "quartz-routing": "/quartz-routing/static-1.603",
  "quick-fetch": "/quick-fetch/static-1.4001",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4770",
  "ts-schema": "/ts-schema/static-1.4164",
  "ui-universal-auth": "/ui-universal-auth/static-1.9114",
  "UIComponents": "/UIComponents/static-3.8535",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3481",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3450",
  "quartz-webpack": "/quartz-webpack/static-1.3397",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.251",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4429",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4987",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2261",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9536",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.36",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5425",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2190",
  "ui-fonts": "/ui-fonts/static-1.851",
  "ui-images": "/ui-images/static-2.1181",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3028",
  "foundations-theming-base": "/foundations-theming-base/static-1.3530",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.769",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3245",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4439",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9246",
  "ai-rendering-library": "/ai-rendering-library/static-1.10588",
  "chirp-fetch": "/chirp-fetch/static-1.2000",
  "connections-embed-lib": "/connections-embed-lib/static-1.1208",
  "copilot-toolkit": "/copilot-toolkit/static-1.11433",
  "feedback-loader": "/feedback-loader/static-1.29514",
  "laboratory-lib": "/laboratory-lib/static-3.7267",
  "marketplace-embed": "/marketplace-embed/static-1.22451",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10047",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20107",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14322",
  "sanitize-text": "/sanitize-text/static-1.8259",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8817",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5876",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5148",
  "wootric-nps": "/wootric-nps/static-1.7066",
  "quartz-head": "/quartz-head/static-1.838",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4764",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4264",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "reporting-data": "/reporting-data/static-1.68035",
  "cssUtils": "/cssUtils/static-1.824",
  "flux-actions": "/flux-actions/static-1.346",
  "HubStyle": "/HubStyle/static-2.11896",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10320",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10476",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7452",
  "icons": "/icons/static-2.654",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18684",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4625",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5643",
  "quartz-i18n": "/quartz-i18n/static-1.848",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.14",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.371",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.578",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.709",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.34",
  "slack-ui-library": "/slack-ui-library/static-1.10509",
  "fsm": "/fsm/static-1.3842",
  "customer-data-objects": "/customer-data-objects/static-1.7792",
  "property-translator": "/property-translator/static-1.5510",
  "hs-locale-management": "/hs-locale-management/static-1.165",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8041",
  "hs-promise-utils": "/hs-promise-utils/static-1.5705",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4991",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13934",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5719",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7896",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4589",
  "superstore": "/superstore/static-1.4872",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10359",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8071",
  "hub-http-janus": "/hub-http-janus/static-1.845",
  "hubspotter-http": "/hubspotter-http/static-1.4734",
  "immutable-less": "/immutable-less/static-1.4767",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17559",
  "nav-meta": "/nav-meta/static-1.29929",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18149",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3928",
  "property-management-common": "/property-management-common/static-1.5838",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9180",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.544",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.848",
  "quartz-test": "/quartz-test/static-1.848",
  "quartz-tracking": "/quartz-tracking/static-1.552",
  "trellis-components": "/trellis-components/static-1.2209",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.180",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21837",
  "ContentUtils": "/ContentUtils/static-1.68696",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13143",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2611",
  "breeze-engine-core": "/breeze-engine-core/static-1.395",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.250",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40198",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13287",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14741",
  "ExportDialog": "/ExportDialog/static-6.10493",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41596",
  "reporting-snowflake": "/reporting-snowflake/static-1.56653",
  "reporting-ui-components": "/reporting-ui-components/static-2.65306",
  "reporting-visualizations": "/reporting-visualizations/static-1.60111",
  "trellis-theming": "/trellis-theming/static-1.1055",
  "ui-addon-teams": "/ui-addon-teams/static-1.21697",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.181",
  "magpie-lib": "/magpie-lib/static-1.5625",
  "navigation-components": "/navigation-components/static-1.18292",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1117",
  "magpie-types": "/magpie-types/static-1.5085",
  "simple-logging-lib": "/simple-logging-lib/static-1.3162",
  "ai-studio-lib": "/ai-studio-lib/static-1.11952",
  "app-governance-lib": "/app-governance-lib/static-1.1918",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10627",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8121",
  "ui-product-approvals": "/ui-product-approvals/static-1.28613",
  "ui-tool-access": "/ui-tool-access/static-1.10262",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9421",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5879",
  "usage-tracker-public": "/usage-tracker-public/static-1.7273",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3670",
  "persist-promise": "/persist-promise/static-1.3813",
  "reference-resolvers": "/reference-resolvers/static-1.8288",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4037",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.450",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3131",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3101",
  "atom": "/atom/static-1.5189",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6087",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1656",
  "crm-component-utils": "/crm-component-utils/static-1.39384",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6002",
  "customer-data-properties": "/customer-data-properties/static-1.51970",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7006",
  "property-value-citations": "/property-value-citations/static-1.2584",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8211",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9180",
  "navigation-messaging": "/navigation-messaging/static-1.7619",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10247",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4929",
  "content-icons-ui": "/content-icons-ui/static-1.2258",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9939",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7361",
  "crm-message-bus": "/crm-message-bus/static-1.43283",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22633",
  "events-data-lib": "/events-data-lib/static-1.345",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4835",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4087",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6911",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1096",
  "onboarding-tours": "/onboarding-tours/static-1.16818",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14011",
  "academy-common-lib": "/academy-common-lib/static-1.14201",
  "content-assistance-lib": "/content-assistance-lib/static-1.7938",
  "dashboard-lib": "/dashboard-lib/static-1.81978",
  "file-manager-components": "/file-manager-components/static-1.23944",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18732",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18568",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18560",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20031",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8818",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4873",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11178",
  "user-context": "/user-context/static-1.5223",
  "growth-payments-core": "/growth-payments-core/static-1.25717",
  "reporting-plugins": "/reporting-plugins/static-1.10503",
  "reporting-reports": "/reporting-reports/static-1.67713",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.839",
  "nest": "/nest/static-1.345",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10741",
  "framework-listing-lib": "/framework-listing-lib/static-2.29017",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30976",
  "apps-service-types": "/apps-service-types/static-1.3913",
  "oauth-service-types": "/oauth-service-types/static-1.4367",
  "react-dnd-compat": "/react-dnd-compat/static-1.4728",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.508",
  "onboarding-scopes": "/onboarding-scopes/static-1.6574",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5033",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7755",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15064",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9599",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6090",
  "signup-constants": "/signup-constants/static-1.19123",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8171",
  "card-properties-lib": "/card-properties-lib/static-1.44539",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37409",
  "crm-actions": "/crm-actions/static-1.6454",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43930",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9576",
  "customer-data-tracking": "/customer-data-tracking/static-1.7001",
  "hs-resources": "/hs-resources/static-1.286",
  "pulse": "/pulse/static-1.712",
  "calling-global-api": "/calling-global-api/static-1.64907",
  "calling-internal-common": "/calling-internal-common/static-1.31423",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66289",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58583",
  "commerce-products-lib": "/commerce-products-lib/static-1.9983",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3879",
  "crm-links": "/crm-links/static-1.6421",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4220",
  "external-options-client-types": "/external-options-client-types/static-1.4210",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4300",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.747",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3773",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49140",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4049",
  "smart-property-lib": "/smart-property-lib/static-1.7805",
  "tiered-pricing": "/tiered-pricing/static-1.1515",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11103",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.125",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1167",
  "growth-data-modal": "/growth-data-modal/static-1.5614",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3179",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2248",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.885",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7740",
  "academy-service-client": "/academy-service-client/static-1.3797",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39443",
  "FileManagerLib": "/FileManagerLib/static-1.39584",
  "SafeStorage": "/SafeStorage/static-1.4513",
  "video-embed": "/video-embed/static-1.36142",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28881",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11650",
  "video-data-lib": "/video-data-lib/static-1.35308",
  "content-media-capture": "/content-media-capture/static-1.4861",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23827",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10000",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24628",
  "viral-links-lib": "/viral-links-lib/static-1.7181",
  "data-token-picker": "/data-token-picker/static-1.16611",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.338",
  "timezone-utils": "/timezone-utils/static-2.5357",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17850",
  "ui-addon-opt": "/ui-addon-opt/static-4.8474",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9440",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25676",
  "framework-data-table": "/framework-data-table/static-2.12180",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6979",
  "nudge-client-utils": "/nudge-client-utils/static-1.2823",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1230",
  "switchboard-lib": "/switchboard-lib/static-1.337",
  "app-users-service-client": "/app-users-service-client/static-1.5722",
  "app-users-service-types": "/app-users-service-types/static-1.5130",
  "mini-checkout-client": "/mini-checkout-client/static-1.27091",
  "onboarding-utils": "/onboarding-utils/static-1.5472",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28866",
  "edison-service-client-types": "/edison-service-client-types/static-1.503",
  "crm_data": "/crm_data/static-4.92329",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46333",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16923",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4373",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1246",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19465",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18817",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10684",
  "crm-fe-perf": "/crm-fe-perf/static-1.23016",
  "event-emitter": "/event-emitter/static-1.1062",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.215",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31430",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11149",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6657",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1438",
  "commerce-permissions": "/commerce-permissions/static-1.890",
  "products-iframe-lib": "/products-iframe-lib/static-1.8248",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10631",
  "data-agent-kit": "/data-agent-kit/static-1.387",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10332",
  "policy-lib": "/policy-lib/static-1.6895",
  "react-tinymce": "/react-tinymce/static-1.55546",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10395",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54672",
  "tinymce-plugins": "/tinymce-plugins/static-1.57786",
  "tinymce-themes": "/tinymce-themes/static-1.56642",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2161",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2276",
  "user-context-client": "/user-context-client/static-1.4693",
  "audio-components": "/audio-components/static-1.6094",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37095",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4649",
  "video-components": "/video-components/static-1.13652",
  "outpost": "/outpost/static-1.4283",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6692",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12665",
  "content-media-compositions": "/content-media-compositions/static-2.16672",
  "media-bridge-lib": "/media-bridge-lib/static-1.19126",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4538",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6311",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5194",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3707",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21879",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3964",
  "ts-utils-lib": "/ts-utils-lib/static-1.287",
  "crm-export-dialog": "/crm-export-dialog/static-1.6398",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6555",
  "crm-view-components": "/crm-view-components/static-1.622",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7444",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2580",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2899",
  "whisper-core-api": "/whisper-core-api/static-1.6872",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15114",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5802",
  "settings-content-modals": "/settings-content-modals/static-1.46408",
  "crm_universal": "/crm_universal/static-1.22213",
  "customer-data-email": "/customer-data-email/static-1.18240",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37505",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39832",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12619",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55102",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21781",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18266",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72400",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5457",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9843",
  "utility-belt": "/utility-belt/static-1.2645",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23251",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7713",
  "customer-data-rte": "/customer-data-rte/static-1.33300",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5953",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5220",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38490",
  "trials-service-types": "/trials-service-types/static-1.3996",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36215",
  "sales-views-client-types": "/sales-views-client-types/static-1.4370",
  "hub-http-contrib": "/hub-http-contrib/static-1.3157",
  "interframe": "/interframe/static-3.4874",
  "tinymce-data": "/tinymce-data/static-1.40757",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5322",
  "layout-dnd-components": "/layout-dnd-components/static-1.12669",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11644",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15694",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9137",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7719",
  "social-insights-client-types": "/social-insights-client-types/static-1.22335",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4283",
  "checkout-sdk": "/checkout-sdk/static-3.23934",
  "company-details-components": "/company-details-components/static-1.6311",
  "payment-method-components": "/payment-method-components/static-1.6985",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14701",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3579",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3635",
  "access-control-lib": "/access-control-lib/static-1.10549",
  "EmailComponents": "/EmailComponents/static-1.55088",
  "EmailData": "/EmailData/static-1.53765",
  "redux-less": "/redux-less/static-2.9596",
  "sequences-lib": "/sequences-lib/static-1.8244",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10463",
  "products-ui-components": "/products-ui-components/static-1.40501",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7253",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55118",
  "commerce-products-api": "/commerce-products-api/static-1.2463",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57176",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103078",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81121",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28566",
  "ContentData": "/ContentData/static-1.68771",
  "layout-data-lib": "/layout-data-lib/static-1.9969",
  "checkout-service-types": "/checkout-service-types/static-1.3880",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.810",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4051",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4103",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.670",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18718",
  "pricing-pages-api": "/pricing-pages-api/static-1.14566",
  "ContentComponents": "/ContentComponents/static-2.71652",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10427",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1983",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46600",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1462",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19217",
  "automation-ui-types": "/automation-ui-types/static-1.20135",
  "messaging-types-lib": "/messaging-types-lib/static-1.46337",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4617",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8101",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.649",
  "price-books-api": "/price-books-api/static-1.1241",
  "price-books-components": "/price-books-components/static-1.1299",
  "property-description-translator": "/property-description-translator/static-1.3954",
  "ramp-editor": "/ramp-editor/static-1.449",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3695",
  "totals-ui-components": "/totals-ui-components/static-1.23910",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9404",
  "advanced-menus-core": "/advanced-menus-core/static-1.15320",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12233",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34350",
  "segments-query-core": "/segments-query-core/static-1.1534",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6051",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7452",
  "data-token-views": "/data-token-views/static-1.16592",
  "forms-utils-lib": "/forms-utils-lib/static-1.12799",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13269",
  "simple-menus-core": "/simple-menus-core/static-1.15319",
  "simple-menus-lib": "/simple-menus-lib/static-1.16836",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6992",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.11",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7625",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77430",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4037",
  "web-interactives-components": "/web-interactives-components/static-1.13963",
  "web-interactives-data": "/web-interactives-data/static-1.13964",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.911",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1081",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1090",
  "line-items-api": "/line-items-api/static-1.859",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3901",
  "FireAlarmUi": "/FireAlarmUi/static-1.4590",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4252",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22071",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21534",
  "data-studio-ubb": "/data-studio-ubb/static-1.3055",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27281",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58183",
  "content-management-data-lib": "/content-management-data-lib/static-1.5607",
  "copilot-plugins": "/copilot-plugins/static-1.11406",
  "cta-picker": "/cta-picker/static-1.36703",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3410",
  "editor-components": "/editor-components/static-1.13398",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8564",
  "error-messaging-js": "/error-messaging-js/static-1.5306",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86125",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10760",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1858",
  "smart-content-core": "/smart-content-core/static-1.42755",
  "smart-content-lib": "/smart-content-lib/static-1.43408",
  "social-composer-lib": "/social-composer-lib/static-1.59570",
  "structured-content-lib": "/structured-content-lib/static-1.25498",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53557",
  "tinymce-copilot": "/tinymce-copilot/static-1.16740",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8054",
  "automation-ui-routing": "/automation-ui-routing/static-1.21492",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5728",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42446",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3306",
  "reporting-enablement": "/reporting-enablement/static-1.23318",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21828",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2980",
  "forms-ai-lib": "/forms-ai-lib/static-1.4499",
  "codemirror-dlb": "/codemirror-dlb/static-1.58989",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6549",
  "report-customization-components": "/report-customization-components/static-1.13484",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13333",
  "reporting-filters": "/reporting-filters/static-1.609",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2083"
}
};
